import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { browserHistory, withRouter } from 'react-router';
import ShowOrders from '../components/orders/ShowOrders';
import { clearAuthErrors, fetchOrders, disableOrder, clearOrdersErrors, fetchSalesChannels, bulkSendPending } from '../actions';
import queryString from 'query-string';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Checkbox from 'material-ui/Checkbox';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { cyan900 } from 'material-ui/styles/colors';
import '../assets/stylesheets/OrdersList.scss';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  orders: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
  locationSearch: PropTypes.object,
  status: PropTypes.string,
  salesChannels: PropTypes.object,
};

const statusArray = ['processing', 'shipped', 'canceled'];

class OrdersPage extends Component {
  constructor(props) {
    super(props);
    const values = queryString.parse(this.props.locationSearch);
    this.state = {
      selectedFilters: (values && values.statuses) ? values.statuses.split(',') : ['processing', 'shipped', 'canceled'],
      fromDate: (values && values.fromDate) ? values.fromDate : null,
      fromDateObj: (values && values.fromDate) ? new Date(values.fromDate) : null,
      toDate: (values && values.toDate) ? values.toDate : null,
      toDateObj: (values && values.toDate) ? new Date(values.toDate) : null,
      selectedSalesChannel: null,
      selectedProcessingStatus: null,
    };
    this.getUpdatedOrders = _.debounce(this.getUpdatedOrders, 737);
    this.getChildContext = this.getChildContext.bind(this)
    this.onOrderDisable = this.onOrderDisable.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.getUpdatedOrders = this.getUpdatedOrders.bind(this)
    this.createCheckbox = this.createCheckbox.bind(this)
    this.handleStatusFilters = this.handleStatusFilters.bind(this)
    this.handleSalesChannelsChange = this.handleSalesChannelsChange.bind(this)
    this.handleProcessingStatusChange = this.handleProcessingStatusChange.bind(this)
    this.clearDates = this.clearDates.bind(this)
    this.navigation = this.navigation.bind(this)
    this.renderLable = this.renderLable.bind(this)
    this.executeSearch = _.debounce(this.executeSearch.bind(this), 500)
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  componentWillMount() {
    // TODO: fix authentication - gabo
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearOrdersErrors());
    const query = this.props.query;
    // const selectLimit = { tenant: query.tenant, limit: 1000 };
    const router = this.props.router;
    if (this.props.orders.search && this.props.orders.search.length > 0) {
      query.search = this.props.orders.search;
    }
    // Filter by status(es):
    if (this.state.selectedFilters) {
      query.statuses = this.state.selectedFilters.toString();
    }
    if (this.state.fromDate) {
      query.fromDate = this.state.fromDate;
    }
    if (this.state.toDate) {
      query.fromDate = this.state.toDate;
    }
    if (this.state.selectedSalesChannel) {
      query.salesChannel = this.state.selectedSalesChannel;
    }
    if (this.state.selectedProcessingStatus) {
      query.processingStatus = this.state.selectedProcessingStatus;
    }

    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/orders', query });
    } else {
      this.props.dispatch(fetchOrders(query));
    }
    this.props.dispatch(fetchSalesChannels({ limit: 1000 }));
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.locationSearch !== nextProps.locationSearch) {
      const nextValues = queryString.parse(nextProps.locationSearch);
      const queryStatuses = (nextValues.statuses) ? nextValues.statuses.split(',') : ['processing', 'shipped', 'canceled'];
      this.setState({ selectedFilters: queryStatuses });
      this.getUpdatedOrders(false);
    }
  }
  onOrderDisable(data) {
    this.props.dispatch(disableOrder(data));
  }

  executeSearch(query) {
    const { dispatch, router } = this.props
    const queryLength = query.search.length
    if (queryLength > 0 && queryLength <= 3) return;
    router.push({ pathname: '/orders', query })
    dispatch(fetchOrders(query))
  }

  handleSearchChange(e) {
    const { orders, query } = this.props
    // const nextOrderInput = e.target.value;
    // const nextOrder = (nextOrderInput !== '') ? nextOrderInput : '';
    orders.search = e.target.value;
    this.setState({
      orders,
    });
    if (e.target.value && e.target.value.length) {
      query.search = e.target.value;
    } else {
      delete query.search;
    }
    query.page = 1;
    query.statuses = this.state.selectedFilters.toString(); // convert filter array to string
    if (this.state.fromDate) {
      query.fromDate = this.state.fromDate;
    } else {
      delete query.fromDate;
    }
    if (this.state.toDate) {
      query.toDate = this.state.toDate;
    } else {
      delete query.toDate;
    }
    if (this.state.selectedSalesChannel) {
      query.salesChannel = this.state.selectedSalesChannel;
    } else {
      delete query.salesChannel;
    }
    if (this.state.selectedProcessingStatus) {
      query.processingStatus = this.state.selectedProcessingStatus;
    } else {
      delete query.selectedProcessingStatus;
    }
    this.executeSearch(query)
  }

  getUpdatedOrders(updateRoute = true) {
    const { query, router, dispatch } = this.props;
    // query.page = 1;
    query.statuses = this.state.selectedFilters.toString(); // convert filter array to string
    if (this.state.fromDate) {
      query.fromDate = this.state.fromDate;
    } else {
      delete query.fromDate;
    }
    if (this.state.toDate) {
      query.toDate = this.state.toDate;
    } else {
      delete query.toDate;
    }
    if (this.state.selectedSalesChannel) {
      query.salesChannel = this.state.selectedSalesChannel;
    } else {
      delete query.salesChannel;
    }
    // updating the order by Processing Status
    if (this.state.selectedProcessingStatus) {
      query.processingStatus = this.state.selectedProcessingStatus;
    } else {
      delete query.processingStatus;
    }

    if (updateRoute) router.push({ pathname: '/orders', query });
    dispatch(fetchOrders(query));
  }
  createCheckbox(filter) {
    return (
      <div className="checkbox-status">
        <Checkbox
          label={filter}
          name={filter}
          checked={this.state.selectedFilters.includes(filter)}
          onClick={(e) => {
            e.preventDefault();
            this.handleStatusFilters(filter);
          }}
        />
      </div>
    );
  }
  handleStatusFilters(filter) {
    // Changing state of status-filter
    const new_selectedFilters = this.state.selectedFilters;
    if (new_selectedFilters.includes(filter)) {
      // removing from selected filters
      new_selectedFilters.splice(new_selectedFilters.indexOf(filter), 1);
    } else {
      // adding to selected filters
      new_selectedFilters.push(filter);
    }
    this.setState({ selectedFilters: new_selectedFilters });
    this.getUpdatedOrders();
  }

  handleSalesChannelsChange(event, index, value) {
    this.setState({ selectedSalesChannel: value });
    this.getUpdatedOrders();
  }
  handleProcessingStatusChange(event, index, value) {
    this.setState({ selectedProcessingStatus: value });
    this.getUpdatedOrders();
  }
  clearDates() {
    this.setState({ fromDateObj: null, fromDate: null });
    this.setState({ toDateObj: null, toDate: null });
    this.getUpdatedOrders();
  }
  navigation(route) {
    this.props.dispatch(fetchOrders(route));
    this.props.dispatch(fetchSalesChannels({}));
  }
  renderLable() {
    if (this.state.selectedFilters == 'cart') {
      return <h2>Carts</h2>;
    }
    if (this.state.selectedFilters == 'pending') {
      return <h2>Pending Orders</h2>;
    }

    return <h2>Orders</h2>;
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };

    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    // console.log("this.state.selectedFilters: ",this.state.selectedFilters)
    // console.log("this.state.selectedFilters.indexOf('cart'): ",this.state.selectedFilters.indexOf('cart'))
    // console.log("this.state.selectedFilters.indexOf('pending'): ",this.state.selectedFilters.indexOf('pending'))
    return (
      <div className="orders component" style={authPage}>
        <span style={{ display: 'none', fontFamily: 'Marydale' }}>.</span>
        {this.renderLable()}
        <div className="content">
          <div className="orders-page-buttons">
            <div className="row action-buttons">
              <div className="col">
                <TextField
                  floatingLabelText="Search by Name, Email, or ID"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  inputStyle={styles.inputStyle}
                  value={this.props.orders.search}
                  onChange={this.handleSearchChange}
                  floatingLabelFixed
                />&nbsp;
              </div>
              <div className="col">
                {(this.props.salesChannels && this.props.salesChannels.results && this.props.salesChannels.results.length) ?
                  <SelectField
                    value={this.state.selectedSalesChannel}
                    onChange={this.handleSalesChannelsChange}
                    floatingLabelText="Sales Channel"
                    floatingLabelFixed
                  >
                    <MenuItem
                      key="9000"
                      value={null}
                      primaryText="Any"
                    />
                    {this.props.salesChannels.results.map(salesChannel => (
                      <MenuItem
                        key={salesChannel.id}
                        value={salesChannel.id}
                        primaryText={salesChannel.displayName}
                      />
                    ))}
                  </SelectField>
                  : null}
              </div>
              <div className="col">
                <SelectField
                  value={this.state.selectedProcessingStatus}
                  onChange={this.handleProcessingStatusChange}
                  floatingLabelText="Processing Status"
                  floatingLabelFixed
                >
                  {/* <MenuItem
                  key="0"
                  value={null}
                  primaryText="Any"
                /> */}
                  <MenuItem value="" key={7} primaryText="Any" />
                  <MenuItem value="Customer Review" key={4} primaryText="Customer Review" />
                  <MenuItem value="CR - Not Printed" key={3} primaryText="CR - Not Printed" />
                  <MenuItem value="CR - Contacted" key={2} primaryText="CR - Contacted" />
                  <MenuItem value="CR - Resolved" key={1} primaryText="CR - Resolved" />
                  <MenuItem value="Reprint" key={5} primaryText="Reprint" />
                  <MenuItem value="Refunds/Upcharges" key={6} primaryText="Refunds/Upcharges" />
                </SelectField>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <DatePicker
                  hintText="From Date"
                  id="fromDate"
                  style={{ marginRight: '2%', width: '250px', float: 'left' }}
                  value={this.state.fromDateObj}
                  onChange={(event, date) => {
                    const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                    this.setState({ fromDateObj: date, fromDate: dateString });
                    this.getUpdatedOrders();
                  }}
                />
              </div>
              <div className="col">
                <div>
                  <DatePicker
                    hintText="To Date"
                    id="toDate"
                    style={{ marginRight: '2%', width: '250px', float: 'left' }}
                    value={this.state.toDateObj}
                    onChange={(event, date) => {
                      const dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                      this.setState({ toDateObj: date, toDate: dateString });
                      this.getUpdatedOrders();
                    }}
                  />
                  <IconButton tooltip="Clear Dates" onClick={this.clearDates}>
                    <FontIcon className="fa fa-trash" />
                  </IconButton>
                </div>
              </div>
              <br />

            </div>
            <div className="row">
              {(this.state.selectedFilters.indexOf('cart') === -1 && this.state.selectedFilters.indexOf('pending') === -1) ?
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <h4>Status</h4>
                  {statusArray.map(this.createCheckbox)}
                  <br />
                </div>
                : null}
            </div>
          </div>
          <div className="top-pagination">
            <Pagination
              paginationInfo={this.props.orders.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <div>
            <ShowOrders
              orders={this.props.orders.results}
              onOrderDisable={data => this.onOrderDisable(data)}
            />
          </div>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.orders.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
          &nbsp;&nbsp;
        <button type="button" onClick={e => {
          e.preventDefault();
          this.props.dispatch(bulkSendPending(this.props.query.page, true))
        }}>Bulk Send SAGE</button>
      </div>
    );
  }
}

OrdersPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OrdersPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    orders: state.orders,
    query: ownProps.location.query,
    status: ownProps.location.status,
    locationSearch: ownProps.location.search,
    salesChannels: state.salesChannels,
  };
}

export default withRouter(connect(mapStateToProps)(OrdersPage));



// WEBPACK FOOTER //
// ./src/containers/OrdersPage.js